import FDBCursor from "./FDBCursor.js";
class FDBCursorWithValue extends FDBCursor {
  value = undefined;
  constructor(source, range, direction, request) {
    super(source, range, direction, request);
  }
  toString() {
    return "[object IDBCursorWithValue]";
  }
}
export default FDBCursorWithValue;